"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intl = require("@kyruus/intl");
/**
 * Internationalized messages for this widget
 * These get passed through `React-Intl`
 * And should follow a format of:
 * Roses are {color_1} and violets are {color_2}
 */
var _default = exports.default = (0, _intl.defineMessages)({
  // appointment_method.*
  // ===================
  appointmentPhoneTitle: {
    id: 'appointment_method.phone_title',
    description: 'Title when visit type is phone',
    defaultMessage: 'Phone Visit'
  },
  appointmentVideoTitle: {
    id: 'appointment_method.video_title',
    description: 'Title when visit type is video',
    defaultMessage: 'Video Visit'
  },
  // aria.*
  // ========
  arialogo: {
    id: 'aria.label.provider.profile.logo',
    description: "Accessibility text for a logo representing a provider's affiliation",
    defaultMessage: 'Logo for {affiliation}'
  },
  ariaproviderreviews: {
    id: 'aria.label.link.providerreviews',
    description: "Accessibility label identifying a link to the provider's reviews",
    defaultMessage: "Go to provider's {reviewCount} reviews"
  },
  ariastarratingsdefault: {
    id: 'aria.label.starratings.default',
    description: "Accessibility label identifying the provider's star ratings",
    defaultMessage: 'Provider star ratings'
  },
  ariastarratingsaverage: {
    id: 'aria.label.starratings.average',
    description: "Accessibility label identifying the provider's star ratings",
    defaultMessage: 'Average provider rating of {averageRating} out of 5 stars'
  },
  maplinklabel: {
    id: 'aria.label.maplink',
    description: "Accessibility label for a link to a map of a provider's office",
    defaultMessage: 'Go to a map of {location}'
  },
  // cta.*
  // ========
  ctabutton: {
    id: 'cta.button',
    description: 'Button text to book an appointment with a provider',
    defaultMessage: 'Book Appointment'
  },
  virtualcarebutton: {
    id: 'cta.modal.virtualcare.buttontext',
    description: 'Call to action button text to begin a virtual care session',
    defaultMessage: 'Virtual Care'
  },
  // provider.profile.*
  // ========
  ratingscale: {
    id: 'provider.profile.ratings.scale',
    description: 'Text that specifies the rating scale',
    defaultMessage: 'out of 5'
  },
  ratingcount: {
    id: 'provider.profile.ratings.ratingcount',
    description: 'The number of ratings that the provider has',
    defaultMessage: '{ratingCount} {ratingCount, plural, one {rating} other {ratings}}'
  },
  // providerlist.*
  // ========
  availability: {
    id: 'providerlist.badge.availability',
    description: 'Badge displaying that the provider is available within a certain number of days',
    defaultMessage: `Available within {days, plural,
      one {# day}
      other {# days}
    }`
  },
  directionslink: {
    id: 'providerlist.directionslink',
    description: "Label for a link that links to directions to the provider's office",
    defaultMessage: 'Directions'
  },
  distance: {
    id: 'providerlist.contact.distance',
    description: 'Table header for a column displaying distances',
    defaultMessage: 'Distance'
  },
  hasvideo: {
    id: 'providerlist.hasvideo',
    description: 'Label to identify that the provider has a video on their profile',
    defaultMessage: 'Video'
  },
  virtualproviderdogearbanner: {
    id: 'providerlist.virtualproviderdogearbanner',
    description: 'Banner to identify that the provider has a virtual/video visits',
    defaultMessage: 'Video Visit'
  },
  maplink: {
    id: 'providerlist.maplink',
    description: "Label for a link that links to map showing the location of the provider's office",
    defaultMessage: 'Map'
  },
  onlinebooking: {
    id: 'providerlist.badge.onlinebooking',
    description: 'Badge displaying that the provider accepts online booking',
    defaultMessage: 'Online booking'
  },
  phone: {
    id: 'providerlist.contact.phone',
    description: 'Table header for a column displaying phone numbers',
    defaultMessage: 'Phone'
  },
  location: {
    id: 'providerlist.contact.location',
    description: 'Table header for a column dislaying provider practice locations',
    defaultMessage: 'Practice Locations'
  },
  action: {
    id: 'providerlist.contact.action',
    description: 'Table header for a column dislaying provider Actions ',
    defaultMessage: 'Actions'
  }
});